import {combineReducers} from 'redux';
import Auth from './Auth';
import Appointments from './Appointments';
import Theme from './Theme';
import Customers from './Customers';
import Search from './Search';
import Cars from './Cars';
import Dashboards from './Dashboards';
import Invoices from './Invoices';
import Parts from './Parts';
import Services from './Services';
import tags from './Tags';
import vendors from './Vendors';
import notifications from './Notifications';
import subscriptions from './Subscriptions';
import accountSubscriptions from './AccountSubscriptions';
import loading from './Loading';
import support from './Support';

const reducers = combineReducers({
	theme: Theme,
	auth: Auth,
	appointments: Appointments,
	customers: Customers,
	search: Search,
	cars: Cars,
	dashboards: Dashboards,
	invoices: Invoices,
	parts: Parts,
	services: Services,
	tags: tags,
	vendors: vendors,
	notifications,
	subscriptions,
	accountSubscriptions,
	loading,
	support,
});

export default reducers;
